export default __webpack_public_path__ + "static/media/Mercenary's Leggings of the Painted Claw.d44e590b.jpg";